import * as React from "react";
import { singleton } from "logic/singleton";
const QueryEditModeContext = React.createContext("query");
export default singleton("views.components.contexts.QueryEditModeContext", () => QueryEditModeContext);
